export const getListCardStyle = ({ isMobile = false } = {}) => ({
  display: "flex",
  flexDirection: "column",
  gap: 8,
  cursor: "pointer",
  boxShadow: "0 10px 24px rgba(0,0,0,0.08)",
  margin: "0 auto",
  maxWidth: isMobile ? 360 : 760,
  width: "100%",
  padding: isMobile ? "12px 12px" : "14px 16px",
  contentVisibility: "auto",
  containIntrinsicSize: isMobile ? "320px" : "280px",
  ...(isMobile ? { marginLeft: -2 } : {}),
});
